import * as React from "react";
import styled from "styled-components";

import { Colors } from "../theme";

const Svg = styled.svg`
  display: block;
  margin: auto;
`;

const Animate = ({ begin, duration, colors, sizes, testName }) => (
  <>
    <animate
      attributeName="r"
      begin={begin + "s"}
      calcMode="linear"
      data-testid={`${testName}-r`}
      dur={duration + "s"}
      repeatCount="indefinite"
      values={sizes}
    />
    <animate
      attributeName="fill"
      begin={begin + "s"}
      calcMode="linear"
      data-testid={`${testName}-fill`}
      dur={duration + "s"}
      repeatCount="indefinite"
      values={colors}
    />
  </>
);

export const Loader = ({
  primary = Colors.Primary,
  secondary = Colors.Secondary,
  fill = primary || Colors.Tertiary,
  testName = "AYMO-Loader",
}) => {
  const colors = `${primary};${secondary};${primary}`;
  const sizes = `7;9;7`;

  return (
    <Svg
      aria-label="Content Loading..."
      data-testid={testName}
      height="21px"
      role="img"
      viewBox="0 0 76 18"
      width="76px"
    >
      <g>
        <circle
          cx="9"
          cy="9"
          data-testid={`${testName}-1-circle`}
          fill={fill}
          r="7"
        >
          <Animate
            begin={0}
            colors={colors}
            duration={1.4}
            sizes={sizes}
            testName={`${testName}-1`}
          />
        </circle>
        <circle
          cx="37"
          cy="9"
          data-testid={`${testName}-2-circle`}
          fill={fill}
          r="7"
        >
          <Animate
            begin={0.35}
            colors={colors}
            duration={1.4}
            sizes={sizes}
            testName={`${testName}-2`}
          />
        </circle>
        <circle
          cx="67"
          cy="9"
          data-testid={`${testName}-3-circle`}
          fill={fill}
          r="7"
        >
          <Animate
            begin={0.7}
            colors={colors}
            duration={1.4}
            sizes={sizes}
            testName={`${testName}-3`}
          />
        </circle>
      </g>
    </Svg>
  );
};

Loader.displayName = "Loader";
